import { SearchIcon } from "app/components/Icons";
import Input from "app/components/Input";
import React from "react";
import { HeaderAreaProps } from "./types";

const HeaderArea: React.FC<HeaderAreaProps> = ({
  handleSelectAll,
  isAllSelected,
  headingText,
  placeholder,
  search,
  setSearch,
  showIsSelected,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <Input
        containerClassName="px-2 pb-1 border-b border-gray-100 "
        id="search"
        placeholder={placeholder ?? "Search by tag name "}
        value={search}
        onChange={(e) => {
          e.stopPropagation();
          setSearch(e.target.value);
        }}
        icon={<SearchIcon size="17" color="#79808A" />}
        noBorder
      />
      {headingText && (
        <div className="flex items-center justify-between px-4 py-3  ">
          <span className="text-secondary text-sm font-semibold uppercase">
            {headingText}
          </span>
          {showIsSelected && (
            <button
              className=" text-sm font-medium text-primary  "
              onClick={handleSelectAll}
            >
              {isAllSelected ? "Unselect All" : "Select All"}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default HeaderArea;
